import React from "react";
import { Container, Row, Alert } from "react-bootstrap";

export const RateLimitPage = () => {
  return (
    <Container>
      <Row>
        <Alert variant="light">
          <Alert.Heading>Whoa there!</Alert.Heading>
          <div>You have exceeded a rate limit.</div>
          <div>Please wait a few minutes before you try again.</div>
        </Alert>
      </Row>
    </Container>
  );
};

export default RateLimitPage;
